<template>
    <div class="bespoke">
        <div class="crumb">
            <a href="/">首页</a> &gt; 定制站点
        </div>
        <div class="tailor">
            <!--<div class="dest cat-items" v-on:drop="drop" v-on:dragover="allowDrop">-->
            <div class="dest">
                <div class="header">
                    <div class="h-title">
                        自定义
                        <span class="dest-hint" @click="showHelp"><img src="../assets/images/info.png" class="hint-img">帮助</span>
                    </div>
                </div>
                <div class="user-cat" v-for="(cat, cindex) in userCats" v-bind:key="cindex">
                    <div class="cat-header">
                        <span class="title">{{cat.attrs.cname}}</span>
                        <button class="del-cat-btn" @click="delCat(cindex)">删 除</button>
                    </div>
                    <div :id="['bes' + cat.cat]" v-on:drop="drop" v-on:dragover="allowDrop">
                        <div class="cat-items none" v-if="cat.valid === 0" :data-cindex="cindex">
                            <span :data-cindex="cindex">请从右侧选择网站图标长按拖动到此处</span>
                        </div>
                        <div class="cat-items"  v-else v-for="i in cat.rc" v-bind:key="i" :data-cindex="cindex">
                            <div v-for="(site, sindex) in cat.sites.slice((i - 1) * descItemNum, i * descItemNum)" v-bind:key="sindex"
                                 class="desc-item-box" :data-cindex="cindex">
                                <div class="desc-item bg"
                                     draggable="true"
                                     v-bind:id="site.site"
                                     :class="site.site"
                                     :style="{'background-image': 'url(' + site.attrs.logo + ')'}"
                                     v-on:dragstart="drag"
                                     v-if="site.site !== 'aknull'">
                                    <div class="del-desc-item" @click="delDescItem(cindex, (i - 1) * descItemNum + sindex)">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="add-cat">
                    <div class="add-cat-real" v-if="addingCat">
                        <input class="input-cat-name" maxlength="20" minlength="1" placeholder="请输入新分类名(1~20字)" v-model="newCatName">
                        <button class="add-name-btn" @click="addCat">创 建</button>
                    </div>
                    <div class="add-cat-fake" v-else>
                        <button class="add-name-btn-fake" @click="addingCat = true">增加分类</button>
                    </div>
                </div>
            </div>
            <div class="source">
                <div class="header">
                    <div class="h-title">
                        数据源
                    </div>
                </div>
                <div class="category" v-for="(cat, cindex) in cats" v-bind:key="cindex">
                    <div class="cat-header">
                        <span class="title">{{cat.attrs.cname}}</span>
                    </div>
                    <div class="cat-items" v-for="i in cat.rc" v-bind:key="i">
                        <div v-for="(site, sindex) in cat.sites.slice((i - 1) * srcItemNum, i * srcItemNum)" v-bind:key="sindex"
                             :style="{width: cwidth + 'px', height: cwidth + 'px'}"
                             class="src-item-box" :class="{tborder: site.site !== 'aknull'}">
                            <!--<div class="src-item" :style="{width: cwidth + 'px', height: cwidth + 'px'}">-->
                            <div class="src-item bg"
                                 draggable="true"
                                 v-bind:id="cindex + '#' + ((i-1) * srcItemNum + sindex)"
                                 :class="site.site"
                                 :style="{'background-image': 'url(' + site.attrs.logo + ')'}"
                                 v-on:dragstart="drag"
                                 v-if="site.site !== 'aknull' && site.used === false">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="tailor-help" v-if="showingHelp">
            <div class="help-mask" @click="showingHelp = false">
                <div class="help-content">
                    <div class="title">定制站点</div>
                    <div class="content">
                        <p>Q: 这个功能有什么用?</p>
                        <p>A: 随着内容来源网站逐渐增加，首页只能展示部分内容，您可以根据自己的兴趣爱好从来源网站中选择您想看的。</p>
                        <p>Q: 如何使用?</p>
                        <p>A: 这个操作十分方便，按照提示说明，您输入要创建的分类名称点击创建，然后用鼠标左边长按住右侧内容来源网站的图标拖动到文字提示区域，然后重复这个操作就可以了</p>
                        <p>Q: 怎么保存?</p>
                        <p>A: 这个操作是即时自动保存的，你创建分类拖动到网站到左侧之后直接回到首页就可以看到修改后的效果</p>
                        <p>Q: 怎么取消?</p>
                        <p>A: 如果您想恢复为首页默认网站分类，把您自定义的所有分类删除即可</p>
                        <p>Q: 为什么拖动图标没有反应?</p>
                        <p>A: 这里用的是HTML 5标准里的drag&drop接口，目前主流浏览器全部支持，所以如果您碰到这种情况极大可能性是由于浏览器插件屏蔽导致，目前已知有用户在使用某些Tampermonkey（油猴）脚本时会导致浏览器drag&drop功能无法使用。</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
export default {
    name: "bespoke",
    data() {
      return {
        srcItemNum: 5,
        descItemNum: 5,
        cats: [],
        cwidth: 105,
        newCatName: '',
        userCats: [],
        // catCount: 0,
        addingCat: true,
        srcSitesPos: {}, // 缓存每个网站的位置，便于从初始数据构建出userCats
        showingHelp: false,
      }
    },
  created: function () {
    var that = this
    this.$http.get('/bespoke', {}, function (r) {
      if (r.status === 0) {
        var _cats = r.data.cats
        var _ucats = r.data.ucats
        for(var i =0; i < _cats.length; i++){
          _cats[i]['rc'] = Math.ceil(_cats[i]['sites'].length / that.srcItemNum)
          //控制item是显示完整还是单独的一个图标
          // _cats[i]['mode'] = 'collapse'
          //计算需要填充的空item数目
          var _nullNum = 0
          if(_cats[i]['sites'].length % that.srcItemNum !== 0){
            _nullNum = that.srcItemNum - _cats[i]['sites'].length % that.srcItemNum
          }
          for(var j = 0; j < _cats[i]['sites'].length; j++){
            _cats[i]['sites'][j].used = false
            that.srcSitesPos[_cats[i]['sites'][j].site] = {
              cindex: i,
              sindex: j
            }
          }
          var j = 0
          while(j < _nullNum){
            _cats[i]['sites'].push({'site': 'aknull'})
            j++
          }
        }
        that.cats = _cats
        //根据 _ucats 生成 that.userCats
        for(var k = 0; k < _ucats.length; k++){
          _ucats[k]['rc'] = Math.ceil(_ucats[k]['sites'].length / that.descItemNum)
          if(_ucats[k]['sites'].length % that.descItemNum === 0){
            if(_ucats[k]['sites'].length === 0){
              _ucats[k]['rc'] = 1
            }
            else{
              _ucats[k]['rc'] = _ucats[k]['rc'] + 1
            }
          }
          var h = 0
          while(h < _ucats[k]['sites'].length){
            //替换_ucats中sites数据为_cats中的数据
            var _pos = that.srcSitesPos[_ucats[k].sites[h].site]
            var _site = that.cats[_pos.cindex].sites[_pos.sindex]
            _site.cindex = _pos.cindex
            _site.sindex = _pos.sindex
            _ucats[k].sites.splice(h, 1, _site)
            that.cats[_pos.cindex].sites[_pos.sindex].used = true
            h++
          }
          _ucats[k]['valid'] = _ucats[k]['sites'].length
          //填充aknull
          for(var l = 0; l < (_ucats[k]['rc'] * that.descItemNum - _ucats[k]['valid']); l++){
            _ucats[k]['sites'].push({'site': 'aknull'})
          }
        }
        if(_ucats.length > 0){
          that.addingCat = false
        }
        that.userCats = _ucats
      }
    })
  },
  methods: {
    showHelp: function () {
      this.showingHelp = true
    },
    delDescItem: function (cindex, sindex) {
      var _site = this.userCats[cindex].sites[sindex]
      var that = this
      this.$http.delete('/bespoke/cats/' + this.userCats[cindex].cat + '/sites/' + _site.site, {}, function (r) {
        if(r.status === 0){
          // 源站点 used 恢复为false，使用添加时缓存的cindex，sindex
          that.cats[_site.cindex].sites[_site.sindex].used = false
          // 删除站点
          that.userCats[cindex].sites.splice(sindex, 1)
          that.userCats[cindex].valid = that.userCats[cindex].valid - 1
          // 维持table，新增空节点
          that.userCats[cindex].sites.push({site: 'aknull'})
          // 判断是否要删除一行
          if(that.userCats[cindex].valid % that.descItemNum === (that.descItemNum - 1)){
            that.userCats[cindex].rc = that.userCats[cindex].rc - 1
            that.userCats[cindex].sites.splice(-that.descItemNum, that.descItemNum)
          }
        }
        else{
          that.$utils.transitMsg('请求无效', 1500)
        }
      })
    },
    delCat: function (cindex) {
      // 从服务器删除
      var that = this
      this.$http.delete('/bespoke/cats/' + this.userCats[cindex].cat, {}, function (r) {
        if (r.status === 0) {
          // 删除userCats并恢复删除的有效网站到右侧
          var _sites = that.userCats[cindex].sites
          for(var j = 0; j < _sites.length; j++){
            if(_sites[j].site !== 'aknull'){
              // 恢复有效网站
              that.cats[_sites[j].cindex].sites[_sites[j].sindex].used = false
            }
          }
          that.userCats.splice(cindex, 1)
        }
      })
    },
    addCat: function () {
        var _newCatName = this.newCatName.trim()
        if(_newCatName.length < 1 ||
          _newCatName.length > 20){
          this.$utils.transitMsg('分类名长度无效', 1500)
        }
        else{
          // 限制分类数量
          if(this.userCats.length >= 10){
            this.$utils.transitMsg('分类最多10个', 2500)
          }
          else{
            // 判断分类名是否已经存在
            var _has = false
            for(var i = 0; i < this.userCats.length; i++){
              if(this.userCats[i].attrs.cname === _newCatName){
                _has = true
              }
            }
            if(_has){
              this.$utils.transitMsg('分类名已存在', 1500)
            }
            else{
              var that = this
              this.$http.post('/bespoke/cats', {cname: _newCatName}, function (r) {
                if (r.status === 0) {
                  that.userCats.push({
                    cat: r.data.iter,
                    attrs: {
                      cname: _newCatName
                    },
                    rc: 1,
                    valid: 0, // 有效站点数量，非aknull
                    sites:[{site: 'aknull'},
                      {site: 'aknull'},
                      {site: 'aknull'},
                      {site: 'aknull'},
                      {site: 'aknull'},
                    ]
                  })
                  that.newCatName = ''
                  // that.catCount = that.catCount + 1
                  that.addingCat = false
                }
                else{
                  that.$utils.transitMsg('请求无效', 1500)
                }
              })
            }
          }
        }

    },
    allowDrop: function (ev) {
      ev.preventDefault();
    },
    drag: function (ev) {
      ev.dataTransfer.setData("text", ev.target.id);
    },
    drop: function (ev) {
      ev.preventDefault();
      var data = ev.dataTransfer.getData("text");
      console.log('droped: ' + data)
      var cindex = data.split('#')[0]
      var sindex = data.split('#')[1]
      // ev.target.appendChild(document.getElementById(data));
      // this.userCats[cindex].sites.push(
      //   this.cats[cindex].sites[sindex]
      // )
      // alert(ev.target);
      // 通知服务器增加site
      var _uc_cindex = parseInt(ev.target.dataset.cindex)
      var that = this
      this.$http.post('/bespoke/cats/' + this.userCats[_uc_cindex].cat + '/sites/' + this.cats[cindex].sites[sindex].site, {}, function (r) {
        if(r.status === 0){
          var _site = that.cats[cindex].sites[sindex]
          _site.cindex = cindex
          _site.sindex = sindex
          that.userCats[_uc_cindex].sites.splice(that.userCats[_uc_cindex].valid, 1, _site)
          that.userCats[_uc_cindex].valid = that.userCats[_uc_cindex].valid + 1
          //需要新增一行
          if(that.userCats[_uc_cindex].valid % that.descItemNum === 0){
            that.userCats[_uc_cindex].rc = that.userCats[_uc_cindex].rc + 1
            that.userCats[_uc_cindex].sites = that.userCats[_uc_cindex].sites.concat([{site: 'aknull'},
                {site: 'aknull'},
                {site: 'aknull'},
                {site: 'aknull'},
                {site: 'aknull'},
              ]
            )
          }
          that.cats[cindex].sites[sindex].used = true
        }
        else{
          that.$utils.transitMsg('操作无效', 1500)
        }
      })
    }
  }
}
</script>

<style lang="less">
.bespoke{
    .tailor-help{
        .help-mask{
            position: fixed;
            z-index: 4700;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, .7);
            display: table;
            transition: opacity .3s ease;
            .help-content{
                width: 50%;
                min-height: 580px;
                text-align: center;
                margin: auto;
                padding: 20px 0;
                padding-top: 60px;
                color: #FFFFFF;
                font-style: italic;
                z-index: 5100;
                .title{
                    font-size: 1.5rem;
                }
                .content{
                    text-align: left;
                    margin-top: 20px;
                    font-size: 1.2rem;
                    p{
                        padding: 5px 0;
                    }
                }
            }
        }
    }
    .crumb{
        margin: 20px auto;
        width: 1120px;
        /*height: 30px;*/
        border-radius: 5px;
        font-size: 1rem;
        /*background-color: #FFFFFF;*/

    }
    .tailor{
        display: flex;
        /*align-items: center;*/
        justify-content: space-between;
        width: 1120px;
        /*min-height: 100%;*/
        margin: auto;
        .dest{
            width: 450px;
            /*flex: 1;*/
            /*min-height: 650px;*/
            /*min-height: 100%;*/
            border-radius: 5px;
            background-color: #FFFFFF;
            .header{
                .h-title{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    text-align: center;
                    padding: 20px 10px;
                    font-size: 1.3rem;
                    .dest-hint{
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        margin-left: 10px;
                        font-size: 0.9rem;
                        color: #999999;
                        cursor: pointer;
                        .hint-img{
                            width: 14px;
                            margin-right: 3px;
                        }
                    }
                }
                border-bottom: 1px solid #f8f8f8;
            }
            .add-cat{
                margin: 20px auto;
                padding: 0 10px;
                .add-cat-real{
                    display: flex;
                    align-items: center;
                    .input-cat-name{
                        flex: 1;
                        border: 0;
                        border-bottom: 1px solid #E2E2E2;
                        font-size: 1.2rem;
                        padding-bottom: 5px;
                    }
                    .add-name-btn{
                        border-radius: 3px;
                        background-color: #3DB4F1;
                        padding: 5px 5px;
                        border: 0;
                        color: #FFFFFF;
                        font-size: 0.9rem;
                        margin-left: 15px;
                    }
                }
                .add-cat-fake{
                    .add-name-btn-fake{
                        border-radius: 3px;
                        background-color: #3DB4F1;
                        padding: 5px 5px;
                        border: 0;
                        color: #FFFFFF;
                        font-size: 0.9rem;
                    }
                }
            }
            .user-cat{
                width: 100%;
                .cat-header{
                    text-align: left;
                    padding: 0 10px;
                    padding-top: 20px;
                    display: flex;
                    align-items: center;
                    justify-content: left;
                    .title{
                        flex: 1;
                        font-size: 1.2rem;
                    }
                    .del-cat-btn{
                        border-radius: 3px;
                        border: 1px solid #999999;
                        padding: 4px 4px;
                        color: #999999;
                        font-size: 0.7rem;
                        margin-left: 15px;
                        cursor: pointer;
                    }
                }
                .cat-items{
                    /*display: table;*/
                    display: table-row;
                    /*display: flex;*/
                    /*flex-direction: row;*/
                    /*justify-content: space-between;*/
                    /*padding: 0 10px;*/
                    /*padding-top: 20px;*/
                    &.none{
                        display: flex;
                        align-items: center;
                        height: 90px;
                        padding: 10px;
                        font-size: 1rem;
                        color: #999999;
                    }
                    .desc-item-box{
                        display: table-cell;
                        border-radius: 5px;
                        width: 90px;
                        height: 90px;
                        padding: 10px;
                        .desc-item{
                            background-color: #FFFFFF;
                            width: 100%;
                            height: 100%;
                            position: relative;
                            /*padding: 10px 0;*/
                            text-align: center;
                            /*display: flex;*/
                            /*align-items: center;*/
                            /*justify-content: center;*/
                            border: 1px solid #EEEEEE;
                            border-radius: 5px;
                            &.bg{
                                background-size:50% auto;
                                background-repeat: no-repeat;
                                background-position: center;
                                &.zhihu{
                                    background-size: 50% auto;
                                }
                                &.cbo{
                                    background-size: 70% auto;
                                }
                                &.qdaily{
                                    background-size: 30% auto;
                                }
                            }

                            &:hover{
                                .del-desc-item{
                                    position: absolute;
                                    top: 0;
                                    right: 0;
                                    width: 15px;
                                    height: 15px;
                                    cursor: pointer;
                                    /*background-color: #D23023;*/
                                    background-image:url("../assets/images/desc-del.png");
                                    background-size: 15px 15px;
                                }
                            }
                        }
                    }
                }
            }
        }
        .source{
            width: 650px;
            /*height: 650px;*/
            border-radius: 5px;
            background-color: #FFFFFF;
            .header{
                .h-title{
                    text-align: center;
                    padding: 20px 0;
                    font-size: 1.3rem;
                }
                border-bottom: 1px solid #f8f8f8;
            }
            .category{
                width: 100%;
                .cat-header{
                    text-align: left;
                    padding: 0 20px;
                    padding-top: 20px;
                    .title{
                        flex: 1;
                        font-size: 1.2rem;
                    }
                }
                .cat-items{
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    padding: 20px 20px;
                    .src-item-box{
                        border-radius: 5px;
                        width: 100%;
                        height: 100%;
                        &.tborder{
                            border: 1px solid #EEEEEE;
                        }
                        .src-item{
                            background-color: #FFFFFF;
                            /*padding: 10px 0;*/
                            text-align: center;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            width: 100%;
                            height: 100%;
                            border-radius: 5px;
                            &.bg{
                                background-size:50% auto;
                                background-repeat: no-repeat;
                                background-position: center;
                                &.zhihu{
                                    background-size: 50% auto;
                                }
                                &.cbo{
                                    background-size: 70% auto;
                                }
                                &.qdaily{
                                    background-size: 30% auto;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>